import region, { entity } from '../../region.json';
import isStaging from '../../utils/isStaging';

export const NETHERLANDS = {
  externalFormCTALink:
    'https://www.parkncharge.nl/laden-in-je-buurt/openbare-laadpaal-aanvragen/?_gl=1*1qcdwym*_up*MQ..&gclid=CjwKCAjwmaO4BhAhEiwA5p4YL9y2r364Dw0bJExPXrjEVkkHh1kSm-TENxmK3Rw8pjvWWGPvK_MvkhoCTFsQAvD_BwE',
};

export default function matchEntities(entities) {
  return entities.some(currentEntity => currentEntity === entity);
}

export function noSocialMedia() {
  return !matchEntities(['SPAIN', 'POLAND']);
}
export function shouldShowBusinessNumber() {
  return !matchEntities(['SPAIN', 'POLAND', 'NETHERLANDS']);
}
export function filterLinksByEntity(link) {
  return !link?.hide;
}
export function shouldShowAppStoreLinks() {
  return true;
}
export function shouldShowExternalFormCTA() {
  return matchEntities(['NETHERLANDS']);
}

export function isTechPagesOnlyEntity() {
  return Boolean(region.techPagesOnly);
}

// Internal nav-link paths (locale prefix aside) that stay in the header/footer
// on a tech-pages-only site (e.g. Denmark). These mirror the allow-listed pages
// in TECH_ONLY_ALLOWED_ROUTE_NAMES, plus /transparency which is an internal
// route that redirects to an external site.
const TECH_ONLY_VISIBLE_NAV_PATHS = [
  '/register',
  '/terms',
  '/privacy',
  '/receipt',
  '/transparency',
];

// True when a header/footer nav link should be hidden on a tech-pages-only site.
// External links (isExternal or an absolute URL) always stay — only internal
// links pointing at blocked pages are hidden.
export function isNavLinkHidden(link) {
  if (!isTechPagesOnlyEntity()) {
    return false;
  }
  const ref = link?.ref || '';
  if (link?.isExternal || /^https?:\/\//.test(ref)) {
    return false;
  }
  // Strip an optional leading locale segment (e.g. /da/register -> /register).
  const path = ref.replace(/^\/[a-z]{2}(\/|$)/, '/');
  return !TECH_ONLY_VISIBLE_NAV_PATHS.includes(path);
}

export function getLinkBlocks(linksByBlock, locale) {
  return linksByBlock
    .map(block => {
      const bl = block.links
        .filter(filterLinksByEntity)
        .filter(link => !isNavLinkHidden(link))
        .map(link => ({
          ref: link.isExternal ? link.ref : `/${locale}${link.ref}`,
          text: link.text,
          isExternal: link.isExternal,
        }));
      return { name: block.name, links: bl };
    })
    .filter(block => block.links.length);
}
export function allowPopup() {
  return !matchEntities(['FRANCE', 'SPAIN', 'POLAND']);
}
export const ALL_ENTITES = [
  'GERMANY',
  'SWEDEN',
  'FRANCE',
  'SPAIN',
  'UK',
  'POLAND',
];

export const topLevelDomains = {
  GERMANY: 'eu',
  SWEDEN: 'se',
  FRANCE: 'fr',
  SPAIN: 'es',
  UK: 'uk',
  POLAND: 'pl',
  NETHERLANDS: 'nl',
};

export const newsTagId = {
  GERMANY: 40,
  SWEDEN: 41,
  FRANCE: 42,
  SPAIN: 45,
  UK: 39,
  POLAND: 44,
  NETHERLANDS: 43,
};

export const SUPPORTED_LANGS = ['de', 'sv', 'fr'];

export const LANGS_TO_ENTITIES = {
  de: 'GERMANY',
  sv: 'SWEDEN',
  fr: 'FRANCE',
  es: 'SPAIN',
  ...(isStaging && { en: 'UK' }),
};

export function specialCaseSpain(websiteEntity, lang) {
  if (websiteEntity === 'GERMANY' && lang === 'es') {
    return true;
  }
  return false;
}

// Named routes that stay reachable on a tech-pages-only website (e.g. Denmark).
// These are the app/auth landing pages plus a handful of legal/utility pages;
// unnamed routes (app deep-links such as /appdownload and /app/:lang/login, plus
// external redirects) are handled by the pass-through in shouldBlockNonTechPage.
export const TECH_ONLY_ALLOWED_ROUTE_NAMES = [
  'Login',
  'Reset',
  'Confirm',
  'Error',
  'Meter',
  'Account Deleted',
  'Delete Account',
  'Receipt',
  'Register',
  'User Agreement', // /terms
  'Privacy',
];

// True when the current entity only exposes its tech pages and the target route
// is a marketing page that should be replaced by the 404 page.
export function shouldBlockNonTechPage(to) {
  if (!isTechPagesOnlyEntity()) {
    return false;
  }
  // Unnamed routes are app deep-links / redirects (e.g. /appdownload,
  // /app/:lang/login) and the external transparency redirect — keep them.
  // 'Not Found' is the 404 page itself, so it must pass to avoid a loop.
  if (!to.name || to.name === 'Not Found') {
    return false;
  }
  return !TECH_ONLY_ALLOWED_ROUTE_NAMES.includes(to.name);
}

export const SHOW_NON_QWELLO_POLES = matchEntities(['POLAND', 'NETHERLANDS']);

function redirectToNetherlandsExternalForm(to) {
  if (to.path === '/aanvraag') {
    window.location.href = NETHERLANDS.googleFromCTALink;
    return true;
  }
  return false;
}
const disabledLinks = ['FAQ'];
// For now we only have 1 route on the Netherlands website = "tarief"
// except for one route = "aanvraag"
// which redirects to a google form
export function OnlyRunIfNetherlandsEntity(to, next) {
  // if not netherlands then simply ignore;
  if (matchEntities(['NETHERLANDS'])) {
    if (redirectToNetherlandsExternalForm(to)) {
      return true;
    }
    if (disabledLinks.includes(to.name)) {
      next('/');
      return true;
    }
  }
  return false;
}
